import React from 'react'
import SiteGrid from "./SiteGrid"
import './styles/PageBanner.css'
import SquareGrid from "./SquareGrid"
import { randomNumRange } from "app/utils/generalUtils"

export default function PageBanner(props) {

  const { title, subtitle } = props
  const circle4Right = randomNumRange(200, 450)
  const circle5Right = randomNumRange(400, 650)

  return (
    <div className="page-banner">
      <div className="banner-bg">
        <div className="circle circle-2" />
        <div className="circle circle-3" />
      </div>
      <SiteGrid>
        <div className="page-banner-content">
          <h1>{title}</h1>
          {subtitle && <h6>{subtitle}</h6>}
          <div className="circle circle-1" />
          <div 
            className="circle circle-5" 
            style={{right: `${circle5Right}px`}}
          />
          <div 
            className="circle circle-4" 
            style={{right: `${circle4Right}px`}}
          />
          <SquareGrid
            number={25}
            columns={5}
            color="var(--primary)"
          />
        </div>
      </SiteGrid>
    </div>
  )
}
